// Modules
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import VelocityTransitionGroup from 'velocity-react/velocity-transition-group';
import _ from 'lodash';
import moment from 'moment';

import { PageContent } from 'components/page';
import { TableCard, CardHeader } from 'components/content-containers/cards';
import { alerts } from 'modules/alerts/actions';
import { slideClosed, slideOpen } from 'utils/transition-groups';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import FlipMove from 'components/widgets/animation/flip-move';
import PurchaseCard from 'components/models/purchases/purchase-card';
import PurchaseOrder from 'services/data/purchase-order';
import PurchaseOrderForm from 'components/models/purchases/forms/purchase-order-form';
import SVG from 'components/widgets/icons/svg';

import { useCurrentUser } from 'hooks';
import useTicket from '../hooks/useTicket';


function TicketExpenses({ params }) {
  const { ticket, purchaseOrders, updatePurchaseOrders, reloadPurchaseOrders } = useTicket(params.ticketId);
  const { currentUser } = useCurrentUser();
  const [addNewExpense, setAddNewExpense] = useState(false);

  function createPurchaseOrder(values) {
    const formattedValues = _.clone(values);
    delete formattedValues.company;
    formattedValues.createdBy = formattedValues.purchasedBy;
    _.remove(formattedValues.lineItems, (lineItem) => _.every(lineItem, _.isEmpty));

    return PurchaseOrder.create(formattedValues)
      .then(() => reloadPurchaseOrders())
      .then(() => setAddNewExpense(false))
      .catch(alerts.catchError);
  }

  if (!ticket || _.isEmpty(ticket) || _.isEmpty(currentUser)) return null;

  const hasAgreement = _.get(ticket, 'agreement.id');
  if (!hasAgreement) return <EmptyPagePlaceholder src="svg/expense-bill.svg">Add an agreement to add purchases to this ticket!</EmptyPagePlaceholder>;

  const isArchived = ticket.status === 'Archived';
  const purchases = _.orderBy(purchaseOrders, [order => moment(order.date).toDate()], ['desc']);

  _.forEach(purchases, (purchaseOrder) => {
    _.set(purchaseOrder, 'update', updatePurchaseOrders);
  });

  return (
    <PageContent className="bg-medium-blue-grey ticket">
      { !addNewExpense && !isArchived &&
        <div onClick={() => setAddNewExpense(true)} className="full-page-add-link offset-page-padding btn-success">
          <div>
            <SVG src="svg/add.svg" className="add mr-2" />
            <span>Add Purchase Order</span>
          </div>
          <SVG src="svg/expense-bill.svg" />
        </div>
      }
      <div className="ticket-expenses">
        <VelocityTransitionGroup component="div" leave={slideClosed} enter={slideOpen}>
        { addNewExpense &&
          <TableCard className="purchase-card">
            <CardHeader>
              <span>Add Purchase Order</span>
              <SVG src="svg/close.svg" className="close" onClick={() => setAddNewExpense(false)} />
            </CardHeader>
            <PurchaseOrderForm
              initialValues={{
                lineItems: [{}],
                purchasedBy: currentUser.id,
                date: moment().toDate(),
                company: ticket.company.id,
                ticket: ticket.id
              }}
              form={'purchaseOrderForm-new'}
              onSubmit={createPurchaseOrder}
              autoFocusField={'vendor'}
            />
          </TableCard>
        }
        </VelocityTransitionGroup>
        <FlipMove>
          { !addNewExpense && _.map(purchases, (purchaseOrder) =>
            <PurchaseCard key={purchaseOrder.id} purchaseOrder={purchaseOrder} />
          )}
        </FlipMove>
      </div>
    </PageContent>
  );
}

TicketExpenses.propTypes = {
  params: PropTypes.object
};

export default TicketExpenses;
